import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { postAlertasInserirInformacao } from './services'
import { TRequestInserirInformacao } from './types'
import { toast } from "sonner";

const initialState: any = {
  status: "",
  data: ""
}

export const actionPostAlertasInserirInformacao = createAsyncThunk<string, TRequestInserirInformacao>(
  "ACTION_POST_ALERTA_INSERIR_INFORMACAO",
  async (data) => {
    return postAlertasInserirInformacao(data)
  }
)

const slicePostAlertasInserirInformacao = createSlice({
  name: "POST_ALERTA_INSERIR_INFORMACAO",
  initialState,
  reducers: {
    actionResetPostAlertasInserirInformacao: (state) => {
      state.status = ""
      state.data = ""
    }
  },
  extraReducers: {
    [`${actionPostAlertasInserirInformacao.pending}`]: (state) => {
      state.status = "loading"
    },
    [`${actionPostAlertasInserirInformacao.fulfilled}`]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
      toast.success("Dados inseridos com sucesso!")
    },
    [`${actionPostAlertasInserirInformacao.rejected}`]: (state) => {
      state.status = "error"
      toast.error("Erro ao inserir dados. Tente novamente.")
    },
  }
})

export default slicePostAlertasInserirInformacao.reducer
export const { actionResetPostAlertasInserirInformacao } =
  slicePostAlertasInserirInformacao.actions;